import Quill from 'quill';
import { Iframe } from '../interfaces/ui-quill-iframe.interfaces';

/**
 * Introduced an alias to Quill.import function as quillImport.
 * WHY?
 * New angular compiler settings prevent the use of reserved keywords like import
 * as function name. The string parameter was misinterpreted as dependency.
 * Can this settings be changed?
 * Maybe. But I bet it is better to leave it as it is. Why use reserved keywords?
 */
const quillImport = Quill.import.bind(Quill);
const Embed = quillImport('blots/embed');
const defaultWidth: string = '267px';
const defaultHeight: string = '150px';

export class IframeBlot extends Embed {
  static readonly blotName: string = 'iframe';
  static readonly tagName: string = 'div';
  static readonly className: string = 'iframe-container';

  static create(data: Iframe) {
    const node = super.create();
    const content = document.createElement('iframe');
    const overlay = document.createElement('div');
    overlay.classList.add('iframe-overlay');
    node.appendChild(content);
    node.appendChild(overlay);
    content.src = this.extractVideoUrl(data.src);
    const iframeStyle = `width: ${data.width || defaultWidth}; height: ${data.height || defaultHeight}`;
    overlay.setAttribute(`style`, iframeStyle);
    node.setAttribute(`style`, iframeStyle);
    overlay.className += ' iframe-wrapper';
    return IframeBlot.setDataValues(node, data);
  }

  // Set values to the dataset for the blot
  static setDataValues(element, data) {
    const domNode = element;
    Object.keys(data).forEach((key) => {
      domNode.dataset[key] = data[key];
    });
    return domNode;
  }

  // Get the dataset from the provided domNode
  static value(domNode) {
    return domNode.dataset;
  }

  // Checks to see if the URL is a video URL and converts it into the
  // appropriate embeddable URL, otherwise just return the unchanges URL
  static extractVideoUrl(url: string): string {
    const match =
      url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) ||
      url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) {
      return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
    }
    if (match && match === url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
      return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
    }
    return url;
  }

  constructor(domNode) {
    super(domNode);
  }
}
